import askhemiEn from "@/locales/en/askhemi.json";
import authEn from "@/locales/en/auth.json";
import commonEn from "@/locales/en/common.json";
import dashboardEn from "@/locales/en/dashboard.json";
import messageEn from "@/locales/en/message.json";
import navEn from "@/locales/en/nav.json";
import settingsEn from "@/locales/en/settings.json";
import toastEn from "@/locales/en/toast.json";
import validationEn from "@/locales/en/validation.json";
import askhemiZhCn from "@/locales/zh-CN/askhemi.json";
import authZhCn from "@/locales/zh-CN/auth.json";
import commonZhCn from "@/locales/zh-CN/common.json";
import dashboardZhCn from "@/locales/zh-CN/dashboard.json";
import messageZhCn from "@/locales/zh-CN/message.json";
import navZhCn from "@/locales/zh-CN/nav.json";
import settingsZhCn from "@/locales/zh-CN/settings.json";
import toastZhCn from "@/locales/zh-CN/toast.json";
import validationZhCn from "@/locales/zh-CN/validation.json";
import { getCurrentLocale } from "@/stores/locale";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Bundled eagerly rather than lazy-loaded per namespace: two locales of a few
// hundred short strings is well under the PWA's 5MB Workbox precache limit, and
// lazy namespace fetches would fight the app's offline-first precache model.
i18n.use(initReactI18next).init({
	resources: {
		en: {
			common: commonEn,
			nav: navEn,
			auth: authEn,
			settings: settingsEn,
			toast: toastEn,
			validation: validationEn,
			dashboard: dashboardEn,
			message: messageEn,
			askhemi: askhemiEn,
		},
		"zh-CN": {
			common: commonZhCn,
			nav: navZhCn,
			auth: authZhCn,
			settings: settingsZhCn,
			toast: toastZhCn,
			validation: validationZhCn,
			dashboard: dashboardZhCn,
			message: messageZhCn,
			askhemi: askhemiZhCn,
		},
	},
	lng: getCurrentLocale(),
	fallbackLng: "en",
	defaultNS: "common",
	ns: [
		"common",
		"nav",
		"auth",
		"settings",
		"toast",
		"validation",
		"dashboard",
		"message",
		"askhemi",
	],
	interpolation: {
		escapeValue: false, // React already escapes.
	},
	react: {
		useSuspense: false,
	},
});

export default i18n;
